import {
  HttpErrorResponse,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import type { HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment';
import { Observable, defer, throwError } from 'rxjs';
import { finalize, retry, tap } from 'rxjs/operators';
import {
  DatabaseWakeupService,
  isDatabaseStarting,
} from './database-wakeup.service';

/**
 * Repeats an API request while the API answers 503 DATABASE_STARTING (the
 * paused database of dev or int is resuming), so that the data appears
 * without a reload. Registered before AuthInterceptor, so every attempt gets
 * the current token.
 */
@Injectable()
export class DatabaseStartingInterceptor implements HttpInterceptor {
  private wakeup = inject(DatabaseWakeupService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiBase)) {
      return next.handle(req);
    }
    return defer(() => {
      const id = this.wakeup.register();
      return next.handle(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            this.wakeup.succeeded(id);
          }
        }),
        retry({
          delay: (error: unknown) =>
            isDatabaseStarting(error)
              ? this.wakeup.retryAfter(id, error as HttpErrorResponse)
              : throwError(() => error),
        }),
        finalize(() => this.wakeup.settled(id))
      );
    });
  }
}
